<template>
  <div
    :class="{
      'border-t border-light mt-24 pt-24 -mx-24 p-24': !onSignupPage
    }"
  >
    <div
      class="type-headline-lg mb-16"
    >
      {{ $t(headline) }}
    </div>
    <slot />
    <div class="type-sm leading-single">
      <div class="mb-8">
        <img
          src="/icons/check-circle.svg"
          class="h-20 w-20 desk:h-24 desk:w-24 mr-8 inline-block relative -top-2"
        ><span>{{ $t('signup.usp1') }}</span>
      </div>
      <div class="mb-8">
        <img
          src="/icons/check-circle.svg"
          class="h-20 w-20 desk:h-24 desk:w-24 mr-8 inline-block relative -top-2"
        ><span>{{ $t('signup.usp2') }}</span>
      </div>
      <div>
        <img
          src="/icons/check-circle.svg"
          class="h-20 w-20 desk:h-24 desk:w-24 mr-8 inline-block relative -top-2"
        ><span>{{ $t('signup.usp3') }}</span>
      </div>

      <nuxt-link
        v-if="!onSignupPage"
        :to="$manualUrl('/account/signup')"
        class="btn btn--secondary w-full mt-18"
      >
        {{ $t('signup.cta') }}
      </nuxt-link>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  onSignupPage?: boolean;
  headline?: string;
}
withDefaults(defineProps<Props>(), {
  onSignupPage: false,
  headline: 'signup.noAccount',
});
</script>